import { forwardRef, TextareaHTMLAttributes } from 'react'
import { inputClasses } from './Input'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string
    error?: string
    helperText?: string
    required?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({ label, error, helperText, required, className = '', rows = 3, ...props }, ref) => {
    return (
        <div className="space-y-1.5">
            {label && (
                <label className="text-sm font-medium text-slate-900 dark:text-slate-100">
                    {label}
                    {required && <span className="ml-0.5 text-red-500">*</span>}
                </label>
            )}
            <textarea
                ref={ref}
                rows={rows}
                className={`${inputClasses} min-h-[80px] resize-y ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : ''} ${className}`}
                {...props}
            />
            {error && <p className="text-sm text-red-600 dark:text-red-400">{error}</p>}
            {helperText && !error && <p className="text-xs text-slate-500 dark:text-slate-400">{helperText}</p>}
        </div>
    )
})

Textarea.displayName = 'Textarea'
